<template>
  <v-container colum fluid fill-height>
        <v-row>
            <v-col>
                <v-card>
                    <v-toolbar color="secondary" dark>
                      <v-toolbar-title>
                          <v-icon left>mdi-package-variant-closed</v-icon>Cart
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items class="hidden-sm-and-down">
                          <create-cart />
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-row>
                      <v-col cols=3 v-for="cart in list" :key="'cart_'+cart.id">
                        <v-card :color="cart.order_id ? 'white':'grey lighten-3'" height="100%">
                          <v-card-title>
                            {{cart.name}}
                          </v-card-title>
                          <v-card-text>
                            <template v-if="cart.order_id">
                              <v-row>
                                <v-col cols="6">
                                  Order Id : #{{cart.order_id}}
                                </v-col>
                                <v-col cols="6" class="text-right">
                                  <v-chip :color="cart.build.status_id=='backordered'?'danger':'primary'" small>{{cart.build.status_id}}</v-chip>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols=12>
                                  Client : {{cart.client.displayName}}
                                </v-col>
                              </v-row>
                            </template>
                            <template v-else>
                              Empty
                            </template>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CreateCart from '../../components/Cart/CreateCart.vue'
export default {
  components: { CreateCart },
  data: () => ({}),
  computed:{
    ...mapGetters("cart",["list"]),
  },
  mounted: function() {
    this.getCarts()
  },
  methods:{
    ...mapActions("cart", {getCarts: 'list'})
  }
}
</script>

<style>

</style>